import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Button } from 'reactstrap';
import ConfirmationModal from '../../../common/modal/ConfirmationModal';
import { deleteCity } from '../../../../actions';

const DeleteCityButton = ({ cityId, dispatchDeleteCity }) => {
  const [showModal, setShowModal] = React.useState(false);
  const onClickDelete = () => dispatchDeleteCity({ cityId })
  const openModal = () => setShowModal(true);
  const closeModal = () => setShowModal(false);

  return (  
    <Fragment>
      <ConfirmationModal 
      show={showModal}
      onClickConfirm={onClickDelete}
      onClickCancel={closeModal}
    />
      <Button color="danger" onClick={openModal}>
        Eliminar
      </Button>  
    </Fragment>
  )
};

DeleteCityButton.propTypes = {
  cityId: PropTypes.number.isRequired,
  dispatchDeleteCity: PropTypes.func.isRequired,
};

const mapDispatchToProps = {
  dispatchDeleteCity: deleteCity
};

export default connect(null, mapDispatchToProps)(DeleteCityButton);
